import DatalayerNewsletters from './datalayer/datalayer-newsletters';
function UserNewsletters ( session ) {
	this.session = session;
}

UserNewsletters.CACHE_KEY = 'newsletters';
UserNewsletters.CACHE_TIME = 900000;
UserNewsletters.ACCESS_ENDPOINT = '/wp-json/ns-subscribers/v1/newsletters/subscribed';

UserNewsletters.prototype.init = function () {
	const sessionData = this.session.getItem( UserNewsletters.CACHE_KEY );

	try {
		if ( typeof window.APP_USER === 'undefined' ) {
			//user not logged in
			if ( sessionData ) {
				this.session.removeItem( UserNewsletters.CACHE_KEY );
			}
			const datalayerNewsletters = new DatalayerNewsletters();
			datalayerNewsletters.pushDatalayer( {} );
		} else if ( typeof window.TAXONOMY_PROMOTION_CODE !== 'undefined' ) {
			// On taxonomy page
			if ( sessionData && this.isValidCache( sessionData ) ) {
				const sessionNewsletters = JSON.parse( sessionData );
				this.displayTaxonomySignUpButton( sessionNewsletters.data );
			} else {
				this.manageNewsletters( true );
			}
		} else {
			// Either on newsletter sign-up or my-account page
			this.manageNewsletters( false );
		}
	} catch ( e ) {
		throw new Error( 'Unable to retrieve User newsletter:' + e.message );
	}
};

UserNewsletters.prototype.manageNewsletters = function ( displayBanner ) {
	let sessionNewsletters = this.session.getItem( UserNewsletters.CACHE_KEY );

	if ( sessionNewsletters ) {
		sessionNewsletters = JSON.parse( sessionNewsletters ).data;
		this.session.removeItem( UserNewsletters.CACHE_KEY );
	}

	const xhr = new XMLHttpRequest();
	xhr.onreadystatechange = function () {
		if ( xhr.readyState === 4 ) {
			let newsletters = {};
			if ( 200 === xhr.status ) {
				const responseObject = JSON.parse( xhr.responseText );
				//newsletters can be empty [] if there was an issue retrieving newsletters
				newsletters = this.processNewsletter( responseObject );
				if ( displayBanner ) {
					this.displayTaxonomySignUpButton( newsletters );
				}
				this.setSessionItem( newsletters );
			}

			const datalayerNewsletters = new DatalayerNewsletters();

			datalayerNewsletters.pushDatalayer( {
				currentNewsletters: newsletters,
				sessionNewsletters,
			} );

			if ( Object.keys( newsletters ).length === 0 ) {
				throw new Error(
					'Problem retrieving User newsletters. Error code ' + xhr.status,
				);
			}
		}
	}.bind( this );
	xhr.open( 'GET', UserNewsletters.ACCESS_ENDPOINT );
	xhr.send();
};

UserNewsletters.prototype.setSessionItem = function ( data ) {
	const dataSet = {};
	dataSet.data = data;
	dataSet.time = Date.now() + UserNewsletters.CACHE_TIME;
	this.session.setItem( UserNewsletters.CACHE_KEY, JSON.stringify( dataSet ) );
};

UserNewsletters.prototype.isValidCache = function ( cacheData ) {
	try {
		const cacheObj = JSON.parse( cacheData );
		return cacheObj.time && Date.now() < cacheObj.time;
	} catch ( e ) {
		return false;
	}
};

UserNewsletters.prototype.displayTaxonomySignUpButton = function ( data ) {
	for ( const newsletter in data ) {
		if ( newsletter === window.TAXONOMY_PROMOTION_CODE ) {
			if ( ! data[ newsletter ] ) {
				const element = document.querySelector( '.archive__newsletter-button' );
				if ( element ) {
					element.classList.remove(
						'archive__newsletter-button--hidden',
					);
					element.classList.add(
						'archive__newsletter-button--display',
					);
				}
			}
			break;
		}
	}
};

UserNewsletters.prototype.processNewsletter = newsletters => {
	const processedNewsletters = {};

	for ( const [ key, value ] of Object.entries( newsletters ) ) {
		processedNewsletters[ key ] = value.status;
	}

	return processedNewsletters;
};

const userNewsletters = new UserNewsletters( window.sessionStorage );
if ( 'loading' !== document.readyState ) {
	userNewsletters.init();
} else {
	document.addEventListener( 'DOMContentLoaded', () => {
		userNewsletters.init();
	} );
}
